import { FC } from "react";

import { VnBox } from "@/components/VnBox";
import { VnLoadingSpinner } from "@/components/VnLoadingSpinner";
import { cn } from "@/utils/tailwind";

type LoadingScreenPropsType = {
  className?: string;
};

export const LoadingScreen: FC<LoadingScreenPropsType> = ({ className }) => {
  return (
    <VnBox
      className={cn("bg-background flex-1 items-center justify-center", {
        className,
      })}>
      <VnLoadingSpinner size={40} className="-mt-32" />
    </VnBox>
  );
};
